import React, { useState, useRef, useEffect } from "react";
import Styles from "../../../assets/css/Blogs/PerfectGiftsGuide/OLED.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const OLED = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const OLED = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/PerfectGiftsGuide/OLED/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./2.avif"),
    ProductImages("./3.avif"),
    ProductImages("./4.avif"),
    ProductImages("./5.avif"),
    ProductImages("./7.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[4]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (OLED.current) {
        const { width, height } = OLED.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>OLED - Perfect Gift for Tech Enthusiasts?</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the stunning visuals of OLED technology, the perfect gift for tech enthusiasts."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="OLED, OLED display, tech gifts, high-quality display, perfect gifts guide"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="OLED - Perfect Gift for Tech Enthusiasts?"
        />
        <meta
          property="og:description"
          content="Discover the stunning visuals of OLED technology, the perfect gift for tech enthusiasts."
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/PerfectGiftsGuide/oled"
        />
        {/* <meta property="og:image" content="/images/OLED/7.png" /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="OLED - Perfect Gift for Tech Enthusiasts?"
        />
        <meta
          name="twitter:description"
          content="Discover the stunning visuals of OLED technology, the perfect gift for tech enthusiasts."
        />
        {/* <meta name="twitter:image" content="/images/OLED/7.png" /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/PerfectGiftsGuide/oled"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={OLED} className={Styles.OLEDContainer}>
        <section className={Styles.OLEDSection1}>
          <div className={Styles.OLEDSection1Text1Container}>
            {/* <h1>Powerful Compact Spotlight for Every Adventure 🌟</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[4]}`}
            alt="OLED"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.OLEDSection1Text2Container}>
            <h1>| OLED |</h1>
            <h1>🎁A Gift That Redefines Gaming 🎮</h1>
            <p>
              Looking for the ultimate gift for a gamer? A high-performance
              gaming monitor is the perfect way to enhance their experience.
              With cutting-edge technology, ultra-fast response time, and
              breathtaking visuals, it transforms gaming into a whole new level
              of immersion. Whether your loved one enjoys competitive gaming or
              cinematic adventures, this display provides smooth motion,
              stunning clarity, and vibrant colors that make every moment feel
              lifelike. With a lightning-fast refresh rate and ultra-low
              response time, every frame is crisp and seamless.
            </p>
          </div>
          <div className={Styles.OLEDSection1Img2Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="OLED"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="OLED"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.OLEDSection1Text3Container}>
            <h1>Unmatched Features & Benefits🔥✨</h1>
            <p>
              <span style={{ color: "black" }}>Ultra-Fast Refresh Rate </span>{" "}
              ✅ Enjoy fluid, stutter-free gaming with an impressive 240Hz
              refresh rate.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Lightning-Fast Response Time
              </span>{" "}
              ✅ A 0.03ms response ensures no motion blur, keeping gameplay
              sharp and responsive.
            </p>
            <p>
              <span style={{ color: "black" }}>Next-Gen Color Accuracy</span> ✅
              uantum dot technology delivers rich, true-to-life colors.
            </p>
            <p>
              <span style={{ color: "black" }}>True Black HDR</span> ✅ Deeper
              blacks and high contrast bring visuals to life.
            </p>
            <p>
              <span style={{ color: "black" }}>Eye-Care Technology</span> ✅
              Designed to reduce strain during long gaming sessions.
            </p>
            <p>
              <span style={{ color: "black" }}>Future-Proof Connectivity</span>{" "}
              ✅ Equipped with advanced ports for seamless device integration.
            </p>
          </div>
          <div className={Styles.OLEDSection1Img3Container}>
            <img
              src={`${ProductImagesArray[0]}`}
              alt="OLED"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[1]}`}
              alt="OLED"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.OLEDSection1Text4Container}>
            <h1>Take Gaming to the Next Level 🚀</h1>
            <p>
              A gaming monitor isn't just a display—it’s an investment in an
              immersive experience. Whether upgrading a setup or surprising a
              gamer with the ultimate gift, this is a game-changer. Elevate
              their play and bring their favorite worlds to life with
              cutting-edge technology.
            </p>
          </div>
          <div className={Styles.OLEDSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/3EFmGCH"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.OLEDSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.OLEDSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.OLEDSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #GamingMonitor #TechGift #4KGaming #NextGenGaming #HDRDisplay
              #FastRefreshRate #GamingSetup #UltimateGift #ImmersiveGaming
              #GamingGear
            </p>
            <h1>Keywords</h1>
            <p>
              High-performance gaming monitor for immersive gameplay Best 4K
              gaming display with ultra-fast refresh rate Advanced technology
              for seamless gaming experience Quantum dot display with true black
              HDR Gift ideas for gamers and tech enthusiasts Eye-care gaming
              monitor for long sessions Smooth motion and vibrant colors for pro
              gamers
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default OLED;
